export default __webpack_public_path__ + "static/media/CircularStd-500.3fcb6535.ttf";